import React from 'react';
import { Table2 } from 'lucide-react';

/**
 * The quiet standing reference to the Smart BOM version viewer: a pill-style
 * button shown ONLY on the supplier-discovery sub-step (the reveal card is
 * what introduces the Smart BOM; earlier sub-steps stay clean so the moment
 * is earned). Cobalt action styling — opening the sheet is the USER's
 * action, never violet. The version number renders only once the server has
 * said what it is — no fabricated counts.
 *
 * Presentational: SmartBomDiscoveryPanel owns the data and the modal.
 */
export interface SmartBomButtonProps {
  /** Real latest version from the server, or null while unknown. */
  latestVersion: number | null;
  onClick: () => void;
  className?: string;
}

export const SmartBomButton: React.FC<SmartBomButtonProps> = ({
  latestVersion,
  onClick,
  className = '',
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`inline-flex items-center gap-s2 rounded-pill border border-action-border bg-action-bg
      px-s4 py-[3px] text-meta font-medium text-action transition-colors
      hover:border-action hover:bg-surface
      focus:outline-none focus-visible:ring-2 focus-visible:ring-action ${className}`}
    title="Open the Smart BOM sheet — every version, with the reasoning behind each change"
  >
    <Table2 className="h-[12px] w-[12px]" />
    Smart BOM
    {latestVersion !== null && (
      <span className="font-mono text-mono-data leading-none">· v{latestVersion}</span>
    )}
  </button>
);

export default SmartBomButton;
